import { AuditService } from "../services/audit.service";
import { LogUpload } from "./log-upload";
import { log } from "./logging";

let audioElement: HTMLAudioElement
let isAudioElementPlayable: boolean = false;
let isNotificationSoundOn: boolean = true;
let isNotificationSoundCurrentlyPlaying: boolean = false;

export const setNotificationSound = (): void => {
    try {
        audioElement = new Audio(`./assets/audio/notification.mp3`);
        audioElement.addEventListener("canplaythrough", event => {
            log.debug("notification mp3 is loaded and ready to be played");
            isAudioElementPlayable = true;
        });
    }
    catch (error) {
        log.error(`An error occurred while setting the audio element`, error)
        new LogUpload("sound").error("setNotificationSound", `An error occurred while setting the audio element`, error);
    }
}

export const playNotificationSound = async (): Promise<void> => {
    if (isAudioElementPlayable === true) {
        if (isNotificationSoundOn === true) {
            if (isNotificationSoundCurrentlyPlaying === false) {
                try {
                    isNotificationSoundCurrentlyPlaying = true;
                    await audioElement.play();
                    isNotificationSoundCurrentlyPlaying = false;
                }
                catch (error) {
                    isNotificationSoundCurrentlyPlaying = false;
                    log.error(`Unable to play notification sound due to an error`, error)
                    new LogUpload("sound").error("playNotificationSound", `Unable to play notification sound due to an error`, error);
                }
            }
            else {
                //a notification is already playing
            }
        }
        else {
            //notification sounds are turned off
        }
    }
    else {
        //audio file is not loaded
    }
}

export const toggleNotificationSoundSetting = (auditService: AuditService): void => {
    let eventId: number = 16;;
    if (!isNotificationSoundOn)
        eventId = 17;

    isNotificationSoundOn = !isNotificationSoundOn;

    auditService.AuditSupervisorUsage(eventId);
}